/**
 *
 * @author Juan Rico
 * @module Advanced
 * @description  Este módulo define el la pagina simulacion AVANZADA.
 * permite realizar la simulacion de soporte vital AVANZADA
 */

//#region  Importaciones necesarias para el la pagina de SOPORTE AVANZADA.
import React, { useState, useEffect, useContext } from "react"; // Importa React y hooks.
import "./advanced.css"; // importacion de la hoja de estilos para esta pagina
import { isMobile, isDesktop, isTablet } from "react-device-detect"; // functiones para detectar tipos de dispositivos
import Header from "../../components/Header/Header"; // Componente de la cabezera de la pagina.
import NSSwitcher from "../../components/NSButton/Types/Switcher"; // Componente para botones de tipo switch
import NSBoolean from "../../components/NSButton/Types/Boolean"; // Componente para botones de tipo Boleano
import NSTimer from "../../components/NSButton/Types/Timer"; // Componente para botones de tipo Tiempo
import NSCounter from "../../components/NSButton/Types/Counter"; // Componente para botones de tipo Contadores
import NSIndicator from "../../components/NSButton/Types/Indicator"; // Componente para botones de tipo indicador
import { faStopwatch } from "@fortawesome/free-solid-svg-icons"; //importa iconos de fontawesome
import DialogVentilaciones from "../../components/DialogVentilaciones/DialogVentilaciones"; // Componente para Pop-up de las ventilaciones
import DialogRitmoPaciente from "../../components/DialogRitmoPaciente/DialogRitmoPaciente"; // Componente para Pop-up del paciente
import DialogEvaluaRitmo from "../../components/DialogEvaluaRitmo/DialogEvaluaRitmo"; // Componente para Pop-up de evaluar ritmo
import DialogDownNotes from "../../components/DialogDownNotes/DialogDownNotes"; // Componente para Pop-up de las notas
import DialogCausaParada from "../../components/DialogCausaParada/DialogCausaParada"; // Componente para Pop-up de la causa de la parada
import DialogTecnicasFarmacos from "../../components/DialogTecnicasFarmacos/DialogTecnicasFarmacos"; // Componente para Pop-up de técnicas y fármacos
import DialogFinish from "../../components/DialogFinish/DialogFinish"; // Componente para Pop-up de finalizacion
import {
  iconAdrenalina, //icono para el boton ADRENALINA / AMIDARONA
  iconAvisaEquipo, //icono para el boton AVISAR EQUIPO DE EMERGENCIA
  iconCausaParada, //icono para el boton CAUSA PARADA
  iconCompresiones, //icono para el boton COMPRESIONES
  iconDesfibrilacion, //icono para el boton DEFRIBILACION
  iconMonitor, //icono para el boton MONITOR
  iconNoResponde, //icono para el boton NO RESPONDE
  iconNotas, //icono para el boton NOTAS
  iconRitmoEcg, //icono para el boton RITMO ECG
  iconTecnicas, //icono para el boton TECNICAS
  iconVentilaciones, //icono para el boton VENTILACIONES
  iconReanimacion, //icono para el boton RCP
  Ic_amiodarona,
  Ic_chrono_L,
  Ic_heart,
} from "../../helpers/ImagesCache"; //Iconos especificos cargados en cache por el desarrolador
import {
  ContextoReset,
  GlobalContext,
  TimelineContext,
} from "../../helpers/Context"; // Contextos de linea de tiempo y global.
import axios from "axios"; // Librería para realizar solicitudes HTTP.
import {
  BASEURLAPI,
  ComponentOptions,
  TimelineDefault,
  DEVMODE,
  OptionsRitmoECGCritical,
  OptionsRitmoECGNormal,
  PlatformMobile,
} from "../../helpers/Constants"; //importa constantes
import DialogHabilidades from "../../components/DialogHabilidades/DialogHabilidades"; // Componente para Pop-up de hailidades luego de finalizar el caso
import DialogNoTecnicas from "../../components/DialogNoTecnicas/DialogNoTecnicas"; // Componente para Pop-up de habilidades no tecnicas
import DialogCalidadRcp from "../../components/DialogCalidadRcp/DialogCalidadRcp"; // Componente para Pop-up de calidad RCP
import DialogMedirAmbas from "../../components/DialogMedirAmbas/DialogMedirAmbas"; // Componente para Pop-up de medir ambas
import Loader from "../../components/Loader/Loader"; //importa componente loader para procesos de espera
import DialogAccesoVascular from "../../components/DialogAccesoVascular/DialogAccesoVascular";
import { useNavigate } from "react-router-dom";
import DialogRitmoInicial from "../../components/DialogRitmoInicial/DialogRitmoInicial";
import SimpleButton from "../../components/NSButton/Types/SimpleButton";

import useTranslation from "../../hooks/useTranslation";
import { useAnalytics } from "../../hooks/useAnalytics";
import useBeforeUnload from "../../hooks/useBeforeUnload";

//#endregion

const Advanced = () => {
  const T = useTranslation();
  const navigate = useNavigate();
  const { 
    trackCaseStart, 
    trackCaseStop, 
    trackPCRStart, 
    trackPCRStop,
    trackROSC,
    trackCompressions,
    trackVentilations,
    trackDefibrillation,
    trackMedication,
    trackRhythmAssessment,
    trackCausaParada,
    trackDialogOpen,
    trackDialogClose,
    trackVascularAccess,
    trackAirwayManagement,
    trackRCPQuality,
    trackNonTechnicalSkills,
    trackReportGenerated
  } = useAnalytics();

  // Estados locales para control de modales y flags
  const [modalState, setModalState] = useState({
    ventilaciones: true,
    ritmoInicial: false,
    accesoVascular: true,
    ritmoPaciente: false,
    evaluarRitmo: false,
    causasParada: false,
    tecnicasFarmacos: false,
    notas: false,
    finish: false,
    habilidades: false,
    noTecnicas: false,
    calidadRcp: false,
    medirAmbas: false,
  });

  // ---- Funciones para abrir y cerrar modales ----
  const openModal = (modalName) =>
    setModalState((prev) => ({ ...prev, [modalName]: true }));
  const closeModal = (modalName) =>
    setModalState((prev) => ({ ...prev, [modalName]: false }));

  const defaultTimerHandleValue = {
    startAt: +new Date(),
    stopAt: +new Date(),
    ritmo: [],
  };
  //#region ############## USO DEL CONTEXTO GLOBAL ##############//
  const ctxReset = useContext(ContextoReset);
  const globalCtx = useContext(GlobalContext);
  const [ctxTimeline, setCtxTimeLine] = useState(TimelineDefault);
  const [History, setHistory] = useState([]);

  //#endregion

  //#region ############## VARIABLES DE ESTADO GENERALES ##############//
  /**
   * Variable de estado para controlar el inicio del caso
   * @type {Boolean}
   * @default false
   */
  const [IsStarted, setIsStarted] = useState(false);

  /**
   * Variable de estado para controlar el PCRFromButton
   * @type {Boolean}
   * @default false
   */
  const [PCRFromButton, setPCRFromButton] = useState(false);

  /**
   * Variable de estado para forzar la detencio del caso
   * @type {Boolean}
   * @default false
   */
  const [ForceStopCase, setForceStopCase] = useState(false);

  /**
   * Variable de estado para determinar si se mediran o no las compresiones
   * @type {Boolean}
   * @default false
   */
  const [compresions, setCompresions] = useState(false);

  /**
   * Variable de estado para establecer el ritmo ecg actual del paciete
   * @type {Boolean}
   * @default false
   */
  const [ecgPaciente, setEcgPaciente] = useState(TimelineContext.ecgPaciente);

  /**
   * Variable de estado para mostrar el ritmo evaluado actual desde el monitor
   * @type {Array}
   * @default []
   */
  //const [ritmo, setRitmo] = useState(TimelineContext.monitor || [])
  const ritmosPcrCritical = OptionsRitmoECGCritical;
  const ritmosPcrNormal = OptionsRitmoECGNormal;

  /**
   * Estado que almacena si hay algun recurso en proceso para bloquear la pantalla a interacciones
   * @type {boolean}
   * @default false - al iniciar esta oculto
   */
  const [isLoading, setIsLoading] = useState(false);

  /**
   * Estado que almacena si hay algun recurso en proceso para bloquear la pantalla a interacciones
   * @type {string}
   * @default 'Guardando informe ...' - al iniciar tiene el texto 'Guardando informe...'
   */
  const [loadingText, setLoadingText] = useState("Guardando informe ...");

  /**
   * Estado que almacena si hay algun recurso en proceso para bloquear la pantalla a interacciones
   * @type {boolean}
   * @default false - al iniciar esta oculto
   */
  const [forceStartCase, setForceStartCase] = useState(false);

  /**
   * Estado que almacena si hay algun recurso en proceso para bloquear la pantalla a interacciones
   * @type {boolean}
   * @default false - al iniciar esta oculto
   */
  const [forceStartPCR, setForceStartPCR] = useState(false);

  /**
   * Estado que almacena si hay algun recurso en proceso para bloquear la pantalla a interacciones
   * @type {boolean}
   * @default false - al iniciar esta oculto
   */
  const [forceStopPCR, setForceStopPCR] = useState(false);

  /**
   * Estado que almacena si hay algun recurso en proceso para bloquear la pantalla a interacciones
   * @type {boolean}
   * @default false - al iniciar esta oculto
   */
  const [PCRStatus, setPCRStatus] = useState(false);

  /**
   * Estado que almacena si hay algun recurso en proceso para bloquear la pantalla a interacciones
   * @type {boolean}
   * @default false - al iniciar esta oculto
   */
  const [IOTStatus, setIOTStatus] = useState(false);

  /**
   * Estado que almacena si hay algun recurso en proceso para bloquear la pantalla a interacciones
   * @type {boolean}
   * @default false - al iniciar esta oculto
   */
  const [AsyncStatus, setAsyncStatus] = useState(false);

  /**
   * Estado que almacena si hay algun recurso en proceso para bloquear la pantalla a interacciones
   * @type {boolean}
   * @default false - al iniciar esta oculto
   */
  const [forceNoResponde, setForceNoResponde] = useState(true);

  /**
   * Estado que almacena si hay algun recurso en proceso para bloquear la pantalla a interacciones
   * @type {boolean}
   * @default false - al iniciar esta oculto
   */
  const [IsAutomaticStart, setIsAutomaticStart] = useState(false);

  // Hook para prevenir navegación hacia atrás durante simulación activa
  const isSimulationActive = IsStarted && !ForceStopCase;
  useBeforeUnload(isSimulationActive, T("navigation_warning_message"));

  //#endregion

  //#region ############## FUNCIONES HANDLE BASICAS ##############//

  /**
   * Manejador del estado forceStopCase
   * @function handleNoRespondeStatus
   * @param boolean - value
   */
  const handleNoRespondeStatus = (value) => setForceNoResponde(value);
  /**
   * Manejador del estado forceStopCase
   * @function handlePCRStatus
   * @param boolean - value
   */
  const handlePCRStatus = (value) => setPCRStatus(value);

  /**
   * Manejador del estado forceStopCase
   * @function handleIOTStatus
   * @param boolean - value
   */
  const handleIOTStatus = (value) => setIOTStatus(value);

  /**
   * Manejador del estado forceStopCase
   * @function handleAsyncStatus
   * @param boolean - value
   */
  const handleAsyncStatus = (value) => setAsyncStatus(value);

  /**
   * Manejador del estado forceStopCase
   * @function handleForceStopCase
   * @param boolean - value
   */
  const handleForceStopCase = (value) => setForceStopCase(value);

  /**
   * Manejador del estado IsStarted para activarlo
   * @function handleStart
   */
  const handleStart = () => setIsStarted(true);

  /**
   * Manejador del estado IsStarted para deshabilitar el caso
   * @function handleStop
   */
  const handleStop = () => {
    setIsStarted(false);
  };

  /**
   * Manejador del estado IsPopupRitmoPacienteActive para cambiar su estado en modo toggle
   * @function handleEcgDialog
   */
  const handleEcgDialog = (value = false, isFromButton = false) => {
    if (value) {
      setIsAutomaticStart(true);
    }
    if (isFromButton) {
      setPCRFromButton(true);
    } else {
      setPCRFromButton(false);
    }
    if (modalState.ritmoPaciente) {
      closeModal("ritmoPaciente");
    } else {
      openModal("ritmoPaciente");
    }
  };

  const handleConfirmEcgPaciente = async (ritmo, closeDialog = false) => {
    if (IsStarted) {
      if (ritmosPcrCritical.filter((i) => i == ritmo).length > 0) {
        setEcgPaciente(ritmo); //Actualizar el valor de ritmo ecgPaciente
        updateHistory(
          "ecgPaciente",
          +new Date(),
          T("ecgRitmoPaciente") + " - ",
          false,
          ritmo,
          null,
          "red"
        ); //agregar el valor ecgPaciente del historial
        updateContext("ecgPaciente", ritmo); //actualizar el valor ecgPaciente del contexto
        if (closeDialog) {
          handleEcgDialog(false, false); //cerrar el popup de ritmo ecg paciente
        }
        await onForceStartPCR(true);
      } else {
        setEcgPaciente(ritmo); //Actualizar el valor de ritmo ecgPaciente
        updateHistory(
          "ecgPaciente",
          +new Date(),
          T("ecgRitmoPaciente") + " - ",
          false,
          ritmo,
          null,
          "green"
        ); //agregar el valor ecgPaciente del historial
        updateContext("ecgPaciente", ritmo); //actualizar el valor ecgPaciente del contexto
        if (closeDialog) {
          handleEcgDialog(false, false); //cerrar el popup de ritmo ecg paciente
        }
        await onForceStopPCR();
      }
    } else {
      setEcgPaciente(ritmo); //Actualizar el valor de ritmo ecgPaciente
      updateContext("ecgPaciente", ritmo); //actualizar el valor ecgPaciente del contexto
      //eventos segun el ecg
      if (ritmosPcrCritical.filter((i) => i == ritmo).length > 0) {
        updateHistory(
          "ecgPaciente",
          +new Date(),
          T("ecgRitmoPaciente") + " - ",
          false,
          ritmo,
          null,
          "red"
        ); //agregar el valor ecgPaciente del historial

        if (IsAutomaticStart) {
          await onForceStartCase(true);
        }
        await onForceStartPCR(true);
      } else if (ritmosPcrNormal.filter((i) => i == ritmo).length > 0) {
        updateHistory(
          "ecgPaciente",
          +new Date(),
          T("ecgRitmoPaciente") + " - ",
          false,
          ritmo,
          null,
          "green"
        ); //agregar el valor ecgPaciente del historial
        if (IsAutomaticStart) {
          await onForceStartCase(true);
        }
      }
      if (closeDialog) {
        handleEcgDialog(false, false); //cerrar el popup de ritmo ecg paciente
      }
    }
  };

  /**
   * Manejador del estado IsPopUpFinish para cambiar su estado en modo toggle
   * @function handleDialogFinish
   */
  const handleDialogFinish = () => {
    openModal("finish");
  };

  /**
   * Manejador del estado para cerrar las habilidades no tecnicas
   * @function handleDialogNoTecnicasStop
   */
  const handleDialogNoTecnicasStop = () => {
    closeModal("noTecnicas");
    closeModal("habilidades");
  };

  /**
   * Manejador del estado para cerrar la calidad rcp
   * @function handleDialogCalidadRcpStop
   */
  const handleDialogCalidadRcpStop = () => {
    closeModal("calidadRcp");
    closeModal("habilidades");
  };

  /**
   * Manejador del estado para cerrar medir ambas
   * @function handleMedirAmbasStop
   */
  const handleMedirAmbasStop = () => {
    closeModal("medirAmbas");
    closeModal("habilidades");
  };

  /**
   * Manejador del estado  para setear la medicion de compresiones activas
   * @function handleCompresions
   */
  const handleCompresions = () => {
    closeModal("ventilaciones");
    setCompresions(true);
  };
  /**
   * Manejador del estado  para setear la medicion de compresiones activas
   * @function handleCloseAcceso
   */
  const handleCloseAcceso = () => {
    closeModal("accesoVascular");
    handleVascularAccessSwitch(false);
  };
  /**
   * Manejador del estado  para setear la medicion de compresiones activas
   * @function handleCloseAcceso
   */
  const handleConfirmAcceso = () => {
    closeModal("accesoVascular");
    handleVascularAccessSwitch(true);
  };

  /**
   * Manejador del estado para finalizar las habilidades no tecnicas
   * y pasar al resumen del reporte
   * @function handleSaveAndCloseNotecnicas
   */
  const handleSaveAndCloseNotecnicas = () => {
    closeModal("noTecnicas");
    closeModal("habilidades");
    handleDialogFinish();
    //SaveReport()
  };

  /**
   * Manejador del estado para finalizar las habilidades no tecnicas
   * y pasar al resumen del reporte
   * @function handleSaveAndCloseNotecnicas
   */
  const handleDialogMedirAmbasConfirm = () => {
    closeModal("noTecnicas");
    closeModal("habilidades");
    closeModal("medirAmbas");
    handleDialogFinish();
    //SaveReport()
  };

  /**
   * Manejador del estado para finalizar la calidad rcp
   * y pasar al resumen del reporte
   * @function handleSaveAndCloseCalidadRcp
   */
  const handleSaveAndCloseCalidadRcp = () => {
    closeModal("calidadRcp");
    closeModal("habilidades");
    handleDialogFinish();
  };
  //#endregion

  //#region ############## FUNCIONES HANDLE AVANZADOS DE COMPONENTES ##############

  const onForceStartCase = async (status) => {
    setForceStartCase(status);
  };

  const onForceStartPCR = async (status) => {
    setForceStartPCR(status);
    handlePCRStatus(status);
  };
  const onForceStopPCR = async () => {
    setForceStartPCR(false);
    await setForceStopPCR(true);
    await handlePCRStatus(false);
    await setForceStopPCR(false);
  };

  /**
   * Handle utilizado para gestionar la accion del pre inicio
   * del cronometro del boton INICIAR CASO para darle alguna accion secundaria
   *
   * @function handleCheckStartCase
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const handleCheckStartCase = async (_value = defaultTimerHandleValue) => {
    if (ecgPaciente != null) {
      await onForceStartCase(true);
    } else {
      openModal("ritmoPaciente");
    }
    openModal("accesoVascular");
  };

  /**
   * Handle utilizado para gestionar la accion del pre inicio
   * del cronometro del boton INICIAR CASO para darle alguna accion secundaria
   *
   * @function handleCheckStartPCR
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const handleCheckStartPCR = (_value = defaultTimerHandleValue) => {
    handleEcgDialog(false, true);
    //nothing
  };

  /**
   * Handle utilizado para gestionar la accion del pre inicio
   * del cronometro del boton INICIAR CASO para darle alguna accion secundaria
   *
   * @function handleCheckStoptPCR
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const handleCheckStoptPCR = (_value = defaultTimerHandleValue) => {
    handleEcgDialog(false, true);
    //nothing
    return true;
  };

  /**
   * Handle utilizado para gestionar la accion del inicio
   * del cronometro del boton INICIAR CASO
   *
   * @function handleStartTimerCase
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const handleStartTimerCase = (_value = defaultTimerHandleValue) => {
    updateContext("startCase", _value.startAt);
    updateHistory("startCase", _value.startAt, "Inicio de Caso");
    handleStart();
    
    // Analytics
    trackCaseStart({
      simulation_type: 'advanced',
      initial_rhythm: ecgPaciente,
      has_vascular_access: ctxTimeline.vascularAccess || false,
      has_airway_device: IOTStatus,
      timestamp: _value.startAt
    });
  };

  const handleStartMonitor = (_value = defaultTimerHandleValue) => {
    console.log("Se presiono handleStartMonitor");
    return;
    updateHistory("monitor", _value.startAt, "Inicia monitor ");
    updateContextPush("monitor", {
      start: _value.startAt,
      stop: _value.stopAt,
    });
  };

  /**
   * Handle utilizado para gestionar la accion de detener
   * del cronometro del boton DETENER CASO
   *
   * @function handleStopTimerCase
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const handleStopTimerCase = (_value = defaultTimerHandleValue) => {
    handleForceStopCase(true);
    updateContext("startCase", _value.startAt);
    updateContext("stopCase", _value.stopAt);
    updateHistory("stopCase", _value.stopAt, "Fin del Caso");
    handleStop();
    
    // Analytics
    const duration = (_value.stopAt - _value.startAt) / 1000; // Convertir a segundos
    trackCaseStop(duration, {
      simulation_type: 'advanced',
      final_outcome: 'completed',
      total_interventions: ctxTimeline.history.length,
      compressions_count: ctxTimeline.compressions.length,
      ventilations_count: ctxTimeline.vents.length,
      shocks_count: ctxTimeline.defibrillation.length,
      medications_count: ctxTimeline.adrenalin.length + ctxTimeline.amiodarone.length
    });
    
    //handleStopDialog()
    openModal("habilidades");
  };

  /**
   * Handle utilizado iniciar la parada cardio respiratoria
   * tiene un cronometro en el boton INICIO PCR
   *
   * @function handleStartTimerPCR
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const handleStartTimerPCR = (_value = defaultTimerHandleValue) => {
    updateContextPush("PCR", {
      start: _value.startAt,
    });
    updateHistory("PCR", _value.startAt, "Inicio PCR");
  };

  /**
   * Handle utilizado para detener la parada cardio respiratoria
   * detiene el cronometro para entrar en modo RCE
   *
   * @function handleStopTimerPCR
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const handleStopTimerPCR = (_value = defaultTimerHandleValue) => {
    handleNoRespondeStatus(true);
    onForceStartPCR(false);

    updateContextPush("RCE", {
      start: _value.startAt,
      stop: _value.stopAt,
    });
    updateHistory("RCE", _value.stopAt, "RCE");
  };

  /**
   * Handle utilizado para gestionar la accion del switch Acceso vascular
   *
   * @function handleVascularAccessSwitch
   * @param _value object - nulleable
   * @default null
   */
  const handleVascularAccessSwitch = (value = null) => {
    updateContext("vascularAccess", value);
    updateHistory(
      "vascularAccess",
      IsStarted ? +new Date() : +new Date(),
      "Acceso vascular",
      false,
      value ? "vascular_access_active" : "vascular_access_inactive",
      null,
      value ? "green" : "red"
    );
  };

  /**
   * Handle utilizado para gestionar la accion del switch IOT/Dispositivo
   *
   * @function handleIotSwitch
   * @param _value object - nulleable
   * @default null
   */
  const handleIotSwitch = (value = null) => {
    handleIOTStatus(value);
    updateContext("otDevice", value);
    updateHistory("otDevice", +new Date(), "IOT/DSG");
  };

  /**
   * Handle utilizado para gestionar la accion del switch IOT/Dispositivo
   *
   * @function handleAsyncSwitch
   * @param _value object - nulleable
   * @default null
   */
  const handleAsyncSwitch = (value = null) => {
    console.log("Se intenta cambiar el modo asincrono");
    handleAsyncStatus(value);

    updateContext("asyncDevice", value);
    updateHistory(
      "asyncDevice",
      +new Date(),
      "Ventilaciones",
      false,
      value ? " - Asíncronas" : " - Síncronas",
      null,
      value ? "blue" : "green"
    );
  };

  /**
   * Handle utilizado para gestionar ç
   * la accion del boton NO RESPONDE
   *
   * @function hanldeNotResposeButton
   * @param _value object - nulleable
   * @default null
   */
  const hanldeNotResposeButton = (value = null) => {
    if (value) {
      updateContext("notRespond", +new Date());
    }
    updateHistory("notRespond", +new Date(), "No responde / No respira");
    handleNoRespondeStatus(false);
  };

  /**
   * Handle utilizado para gestionar
   * la accion del boton NOTIFICAR EQUIPO EMERGENCIA
   *
   * @function hanldeNotifiesEmergencyTeamButton
   * @param _value object - nulleable
   * @default null
   */
  const hanldeNotifiesEmergencyTeamButton = (value = null) => {
    if (value == true) {
      updateContext("notifiesEmergencyTeam", +new Date());
    }
    updateHistory(
      "notifiesEmergencyTeam", //key
      +new Date(), //tiempo
      "Avisa equipo RCP" // titulo
    );
  };

  /**
   * Handle utilizado para gestionar la accion de detener
   * del cronometro del boton COMPRESIONES
   *
   * @function handleStopTimerCompressions
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const handleStopTimerCompressions = (_value = defaultTimerHandleValue) => {
    updateContextPush("compressions", {
      start: _value.startAt,
      stop: _value.stopAt,
    });

    updateHistory(
      "compressions", //key
      _value.stopAt, //tiempo
      "Detiene Compresiones" // titulo
    );
  };

  /**
   * Handle utilizado para gestionar la accion del inicio
   * del cronometro del boton COMPRESIONES
   *
   * @function handleStartTimerCompression
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const handleStartTimerCompression = (_value = defaultTimerHandleValue) => {
    updateHistory(
      "compressions", //key
      _value.startAt, //tiempo
      "Inicia Compresiones" // titulo
    );
  };

  /**
   * Handle utilizado para gestionar la accion de detener
   * del cronometro del boton VENTILACIONES
   *
   * @function handleStopTimerVents
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const handleStopTimerVents = (_value = defaultTimerHandleValue) => {
    updateContextPush("vents", {
      start: _value.startAt,
      stop: _value.stopAt,
    });
    updateHistory(
      "vents", //key
      _value.stopAt, //tiempo
      "Detiene ventilaciones" // titulo
    );
  };

  /**
   * Handle utilizado para gestionar la accion del inicio
   * del cronometro del boton VENTILACIONES
   *
   * @function defaultTimerHandleValue
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const handleStartTimerVents = (_value = defaultTimerHandleValue) => {
    updateHistory(
      "vents", //key
      _value.startAt, //tiempo
      "Inicia ventilaciones" // titulo
    );
  };

  /**
   * Handle utilizado para gestionar la accion de detener
   * del cronometro del boton RCP
   *
   * @function handleStopTimerRcp
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const handleStopTimerRcp = (_value = defaultTimerHandleValue) => {
    updateContextPush("RCP", {
      start: _value.startAt,
      stop: _value.stopAt,
    });
    updateHistory(
      "RCP", //key
      _value.stopAt, //tiempo
      "Detiene RCP" // titulo
    );
  };

  /**
   * Handle utilizado para gestionar la accion del inicio
   * del cronometro del boton RCP
   *
   * @function handleStartTimerRcp
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const handleStartTimerRcp = (_value = defaultTimerHandleValue) => {
    updateHistory(
      "RCP", //key
      _value.startAt, //tiempo
      "Inicia RCP" // titulo
    );
  };

  /**
   * Handle utilizado para gestionar la accion de detener
   * del cronometro del boton DEFIFRILACION
   *
   * @function hanldeStopTimerDefibrillation
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const hanldeStopTimerDefibrillation = (_value = defaultTimerHandleValue) => {
    updateContextPush("defibrillation", {
      start: _value.startAt,
      stop: _value.stopAt,
    });
    updateHistory(
      "defibrillation", //key
      _value.stopAt, //tiempo
      "Desfibrilación", // titulo,
      false, // ocultar
      "", // titulo secundario
      "#F4D947" // color primario
    );
  };

  /**
   * Handle utilizado para gestionar la accion del inicio
   * del cronometro del boton DEFIFRILACION
   *
   * @function handleStartTimerDefibrillation
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const handleStartTimerDefibrillation = (_value = defaultTimerHandleValue) => {
    updateContextPush("defibrillation", {
      start: _value.startAt,
      stop: _value.stopAt,
    });
    updateHistory(
      "defibrillation", //key
      _value.startAt, //tiempo
      "Desfibrilación", // titulo
      false, // ocultar
      "", // titulo secundario
      "#F4D947" // color primario
    );
  };

  /**
   * Handle utilizado para gestionar la accion de detener
   * del cronometro del boton ADRENALINA
   *
   * @function handleStopTimerAdrennalin
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const handleStopTimerAdrennalin = (_value = defaultTimerHandleValue) => {
    updateContextPush("adrenalin", {
      start: _value.startAt,
      stop: _value.stopAt,
    });
    updateHistory(
      "adrenalin", //key
      _value.stopAt, //tiempo
      "Adrenalina" // titulo
    );
  };

  /**
   * Handle utilizado para gestionar la accion del inicio
   * del cronometro del boton ADRENALINA
   *
   * @function handleStartTimerAdrenalin
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const handleStartTimerAdrenalin = (_value = defaultTimerHandleValue) => {
    updateContextPush("adrenalin", {
      start: _value.startAt,
      stop: _value.stopAt,
    });
    updateHistory(
      "adrenalin", //key
      _value.startAt, //tiempo
      "Adrenalina" // titulo
    );
  };

  /**
   * Handle utilizado para gestionar la accion de detener
   * del cronometro del boton AMIDARONA
   *
   * @function handleStopTimerAmiodarone
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const handleStopTimerAmiodarone = (_value = defaultTimerHandleValue) => {
    updateContextPush("amiodarone", {
      start: _value.startAt,
      stop: _value.stopAt,
    });
    updateHistory(
      "amiodarone", //key
      _value.stopAt, //tiempo
      "Amiodarona" // titulo
    );
  };

  /**
   * Handle utilizado para gestionar la accion del inicio
   * del cronometro del boton IAMIDARONA
   *
   * @function handleStartTimerAmiodarone
   * @param _value object - nulleable - defaultTimerHandleValue
   * @default defaultTimerHandleValue - el valor puede traer los valores startAt,stopAt o ritmo
   */
  const handleStartTimerAmiodarone = (_value = defaultTimerHandleValue) => {
    updateContextPush("amiodarone", {
      start: _value.startAt,
      stop: _value.stopAt,
    });
    updateHistory(
      "amiodarone", //key
      _value.startAt, //tiempo
      "Amiodarona" // titulo
    );
  };

  /**
   * Handle utilizado para gestionar
   * la accion CLICK de causa parada
   *
   * @function handleCausaParadaClick
   */
  const handleCausaParadaClick = (values = []) => {
    if (modalState.causasParada) {
      closeModal("causasParada");
    } else {
      openModal("causasParada");
    }
  };

  /**
   * Handle utilizado para gestionar
   * la accion CLICK de tecnicas
   *
   * @function hanldeTecnicasClick
   */
  const hanldeTecnicasClick = () => {
    if (modalState.tecnicasFarmacos) {
      closeModal("tecnicasFarmacos");
    } else {
      openModal("tecnicasFarmacos");
    }
  };

  /**
   * Handle utilizado para gestionar
   * la accion CLICK de confirmacion al Evaluar ritmo
   *
   * @function handleDialogConfirmEvaluaRitmo
   */
  const handleDialogConfirmEvaluaRitmo = (_value = defaultTimerHandleValue) => {
    updateHistory(
      "monitor",
      _value.startAt,
      "Evalúa ritmo - ",
      false,
      _value.ritmo,
      "#000a",
      "#2AAC9C"
    );
    updateContextPush("monitor", {
      start: _value.startAt,
      stop: _value.stopAt,
    });

    closeModal("evaluarRitmo");
  };

  /**
   * Handle utilizado para gestionar
   * la accion CLICK de confirmacion para
   * guardar las notas
   *
   * @function handleDialogConfirmNotes
   */
  const handleDialogConfirmNotes = (text = "") => {
    updateContext("Notas", text);
    if (text != ctxTimeline.Notas) {
      updateHistory(
        "Notas", //key
        +new Date(), //tiempo
        "Notas", // titulo,
        false, // ocultar
        ` ${text}`, // titulo secundario
        "#2AAC9C" // color primario
      );
    }

    closeModal("notas");
  };

  //#endregion

  //#region ############## FUNCIONES AVANZADAS ##############//
  /**
   * Verifica si el informe ya se ha guardado en la base de datos.
   * @async
   * @function reportExist
   * @todo
   * api que verifique la existencia de un reporte
   *
   */
  const reportExist = async () => {
    const url = `${BASEURLAPI}/caseExist`; //la url para la solicitud
    let result = false;
    await axios
      .get(url)
      .then((response) => {
        if (response.status == 200) {
          if (response.data.result == true) {
            result = true;
          }
        }
      })
      .catch((error) => {
        console.log("hubo un error", error);
      });

    return result;
  };

  /**
   * Guarda el ingorme en la base de datos una vez finalizado el caso.
   *
   * @function SaveReport
   * @todo
   * verificar si el informe ya existe
   */

  const SaveReport = async () => {
    try {
      console.log("Iniciando guardado de informe...");
      console.log("Contexto timeline original:", ctxTimeline);

      // Obtener informes existentes
      const existingReportsStr = localStorage.getItem("reports");
      console.log("Informes existentes en localStorage:", existingReportsStr);

      const existingReports = existingReportsStr
        ? JSON.parse(existingReportsStr)
        : [];
      console.log("Informes parseados:", existingReports);

      // Crear nuevo informe con datos serializables
      const newReport = {
        id: +new Date(),
        name: ctxTimeline.name || "Informe",
        timeline: {
          name: ctxTimeline.name || "Informe",
          type: ctxTimeline.type || "advanced",
          date: ctxTimeline.date || +new Date(),
          history: ctxTimeline.history || [],
          startCase: ctxTimeline.startCase || null,
          stopCase: ctxTimeline.stopCase || null,
          PCR: ctxTimeline.PCR || [],
          RCE: ctxTimeline.RCE || [],
          isSafeScene: ctxTimeline.isSafeScene || false,
          shoutedHelp: ctxTimeline.shoutedHelp || false,
          consistency: ctxTimeline.consistency || null,
          notRespond: ctxTimeline.notRespond || null,
          openAirWay: ctxTimeline.openAirWay || [],
          checkVentilation: ctxTimeline.checkVentilation || [],
          notifiesEmergencyTeam: ctxTimeline.notifiesEmergencyTeam || null,
          lateralSafetyPosition: ctxTimeline.lateralSafetyPosition || null,
          RCP: ctxTimeline.RCP || [],
          DEA: ctxTimeline.DEA || [],
          compressions: ctxTimeline.compressions || [],
          vents: ctxTimeline.vents || [],
          defibrillation: ctxTimeline.defibrillation || [],
          adrenalin: ctxTimeline.adrenalin || [],
          amiodarone: ctxTimeline.amiodarone || [],
          naloxone: ctxTimeline.naloxone || [],
          diazepam: ctxTimeline.diazepam || [],
          vascularAccess: ctxTimeline.vascularAccess || false,
          otDevice: ctxTimeline.otDevice || null,
          monitor: ctxTimeline.monitor || [],
          complete: ctxTimeline.complete || false,
          conscious: ctxTimeline.conscious || false,
          toser: ctxTimeline.toser || null,
          backBlows: ctxTimeline.backBlows || [],
          compressionsAbs: ctxTimeline.compressionsAbs || [],
          compressionsThorax: ctxTimeline.compressionsThorax || [],
          basicVitalSupport: ctxTimeline.basicVitalSupport || null,
          Ritmo: ctxTimeline.Ritmo || [],
          ECG: ctxTimeline.ECG || "",
          ecgPaciente: ctxTimeline.ecgPaciente || "",
          CausaT: ctxTimeline.CausaT || [],
          CausaH: ctxTimeline.CausaH || [],
          Tecnicas: ctxTimeline.Tecnicas || [],
          Farmacos: ctxTimeline.Farmacos || [],
          Notas: ctxTimeline.Notas || "",
          deficit: ctxTimeline.deficit || [],
          calidadRcp: ctxTimeline.calidadRcp || [],
          nonTechnical: ctxTimeline.nonTechnical || [],
          rcpQuality: ctxTimeline.rcpQuality || [],
          asyncDevice: ctxTimeline.asyncDevice || false,
        },
        duration: 0,
        date: new Date().toISOString(),
      };

      console.log("Nuevo informe a guardar:", newReport);

      // Añadir nuevo informe al array
      existingReports.push(newReport);
      console.log("Array de informes actualizado:", existingReports);

      // Guardar en localStorage
      const reportsToSave = JSON.stringify(existingReports);
      console.log("Datos serializados a guardar:", reportsToSave);

      localStorage.setItem("reports", reportsToSave);
      console.log("Informe guardado exitosamente");

      // Verificar que se guardó correctamente
      const savedReports = JSON.parse(localStorage.getItem("reports"));
      console.log("Verificación de datos guardados:", savedReports);

      // Resetear timeline y cerrar diálogo
      setCtxTimeLine(TimelineDefault);
      setIsPopupFinish(false);
      setIsPopupFinishStop(false);
      setIsStarted(false);
      setForceStopCase(false);
      setCurrentTimerHandleValue(defaultTimerHandleValue);
      setCurrentTimerHandleValuePCR(defaultTimerHandleValue);
      setCurrentTimerHandleValueCompressions(defaultTimerHandleValue);
      setCurrentTimerHandleValueVents(defaultTimerHandleValue);
      setCurrentTimerHandleValueRcp(defaultTimerHandleValue);
      setCurrentTimerHandleValueDefibrillation(defaultTimerHandleValue);
      setCurrentTimerHandleValueOpenAirWay(defaultTimerHandleValue);
      setCurrentTimerHandleValueCheckVentilation(defaultTimerHandleValue);
    } catch (error) {
      console.error("Error al guardar el informe:", error);
      console.error("Stack trace:", error.stack);
    }
  };

  /**
   * Actualizar el contexto de forma mas simple pasandole el key y el valor
   *
   * @function updateContext
   * @param key string - mandatory
   * @param value any - nulleable
   */
  const updateContext = (key, value = null) => {
    if (DEVMODE) {
      console.log(
        "%cACTUALIZANDO CONTEXTO, Agregando el objeto " + key + " con valor: ",
        "color:#5f5",
        value
      );
    }
    setCtxTimeLine((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  /**
   * Actualizar un elemento del contexto de forma mas simple pasandole el valor
   *
   * @function updateContextPush
   * @param key string - mandatory
   * @param value any - nulleable
   */
  const updateContextPush = (key, value = null) => {
    if (DEVMODE) {
      console.log(
        "%cAGREGANDO AL CONTEXTO PUSH, Agregando el objeto " +
          key +
          " con valor: " +
          value,
        "color:orange"
      );
    }
    setCtxTimeLine((prev) => ({
      ...prev,
      [key]: [...prev[key], value],
    }));
  };

  /**
   * Actualizar el historial de forma mas simple pasandole parametros especificos
   *
   * @function updateHistory
   * @param _object string - nulleable - nombre del key en el contextTimeline de 1er nivel
   * @param _time Date - nulleable - datetime
   * @param _title string - nulleable - titulo que aparece en el reporte
   * @param _hideOnReport boolean - nulleable - si se mostrara o no en el reporte
   * @param _value string - nulleable - valor secundario en el reporte
   * @param _colorPrimario string - nulleable - color del texto secundario
   * @param _colorSecundario string - nulleable - color secundario del texto secundario
   */
  const updateHistory = (
    _object = "",
    _time = +new Date(),
    _title = "-",
    _hideOnReport = false,
    _value = null,
    _colorPrimario = null,
    _colorSecundario = null
  ) => {
    if (DEVMODE) {
      console.log(
        "%cACTUALIZANDO HISTORIAL, Agregando el objeto " + _object,
        "color:yellow"
      );
    }
    setHistory((prev) => [
      ...prev,
      {
        object: _object,
        time: _time,
        title: _title,
        value: _value,
        colorPrimario: _colorPrimario,
        hideOnReport: _hideOnReport,
        colorSecundario: _colorSecundario,
      },
    ]);
  };
  //#endregion

  const middleWare = () =>
    modalState.ritmoInicial
      ? closeModal("ritmoInicial")
      : openModal("ritmoInicial");

  //#region ############## USEEFFECTS ##############//

  // Hook que se ejecuta al montar el componente para verificar el contexto el tipo de caso advance .
  useEffect(() => {
    updateContext("type", "advanced");
  }, []);

  // Hook que se ejecuta al montar el componente para verificar el contextoy setear el ritmo.
  //useEffect(() => { setRitmo(ctxTimeline.monitor || []) }, [ctxTimeline])

  // Hook que se ejecuta al montar el componente y actualiza el historial en el cotexto
  useEffect(() => {
    updateContext("history", History);
  }, [History]);

  //#endregion

  return (
    <>
      <Loader status={isLoading} text={loadingText} />
      <div className="min-h-screen w-screen flex flex-col bg-[#EAF7F5] overflow-y-auto">
        <Header minimal={true} variant={"advanced"} />
        {
          //#region  TEMPORIZADORES GENERALES
        }
        <div
          className="flex gap-5 py-3 lg:mb-2 relative z-[300] bg-[#F9FAFB] justify-center"
          style={{ boxShadow: "0 4px 6px 0 #2AAC9C33" }}
        >
          <NSTimer
            titleOn="Parar caso" //Titulo cuando su estado es activo
            titleOff="Iniciar caso" //Titulo cuando su estado esta inactivo - por defecto
            onCheckStart={handleCheckStartCase}
            onStartTimer={handleStartTimerCase} //Accion al INICIAR el temporizador
            onStopTimer={handleStopTimerCase} //Accion al DETENER el temporizador
            forceStart={forceStartCase}
            forceDisable={ForceStopCase} //Forzar la desactivacion la accion de este componente
            forceStop={ForceStopCase} //Forzar DETENER el temporizador
          />
          <NSTimer
            titleOn="RCE" //Titulo cuando su estado es activo
            titleOff="Iniciar PCR" //Titulo cuando su estado esta inactivo - por defecto
            onCheckStart={handleCheckStartPCR}
            onStartTimer={handleStartTimerPCR} //Accion al INICIAR el temporizador
            onCheckStop={handleCheckStoptPCR}
            onStopTimer={handleStopTimerPCR} //Accion al DETENER el temporizador
            forceStart={forceStartPCR && IsStarted}
            forceDisable={!IsStarted} //Forzar la desactivacion la accion de este componente
            forceStop={ForceStopCase || forceStopPCR} //Forzar DETENER el temporizador
            customStyle
          />
        </div>
        <div>
          <div className="p-2 w-full  h-full " style={styles.switcherSection}>
            {
              //#endregion
              //#region  BOTONES SWITCH
            }
            <div className="w-11/12 flex justify-between pb-2">
              <NSSwitcher
                initialState={ctxTimeline.vascularAccess}
                title={PlatformMobile ? "AV" : "Acceso vascular"} //Titulo visible
                options={ComponentOptions.vascularAccessSwitch} //Opciones personalizadas del componente
                onClick={handleVascularAccessSwitch} //Accion cuando se hace CLICK
                forceDisable={!IsStarted && ForceStopCase} //Forzar la desactivacion la accion de este componente
                forceStop={ForceStopCase} //Forzar DETENER el temporizador
              />

              <NSSwitcher
                title={PlatformMobile ? "IOT/DSG" : "IOT/DSG"} //Titulo visible
                options={ComponentOptions.iotSwitch} //Opciones personalizadas del componente
                onClick={handleIotSwitch} //Accion cuando se hace CLICK
                forceDisable={!IsStarted && ForceStopCase} //Forzar la desactivacion la accion de este componente
                forceStop={ForceStopCase} //Forzar DETENER el temporizador
              />

              <NSSwitcher
                title={"async"} //Titulo visible
                options={ComponentOptions.asyncSwitch}
                onClick={handleAsyncSwitch} //Accion cuando se hace CLICK
                forceDisable={!IOTStatus || (!IsStarted && ForceStopCase)} //Forzar la desactivacion la accion de este componente
                forceStop={ForceStopCase} //Forzar DETENER el temporizador
              />
            </div>

            {
              //#endregion
              //#region  BOTONES VARIABLES DEL CONTENIDO
            }

            <div
              className={`px-2 grid gap-4 justify-center  ${
                isMobile && !isTablet ? "grid-cols-2" : "grid-cols-3"
              }`}
              style={styles.buttonsSeccion}
            >
              <NSBoolean
                title={"No responde/ no respira"} //Titulo visible
                icon={iconNoResponde} //Icono del componente
                initialState={false} //Estado inicial del componente
                onClick={hanldeNotResposeButton} //Accion cuando se hace CLICK
                forceEnable={IsStarted && forceNoResponde} //Forzar la desactivacion la accion de este componente
                forceDisable={!IsStarted} //Forzar la desactivacion la accion de este componente
                forceStop={ForceStopCase} //Forzar DETENER el temporizador
                minimal={PlatformMobile}
              />
              <NSBoolean
                title={"Avisa equipo reanimación"} //Titulo visible
                icon={iconAvisaEquipo} //Icono del componente
                initialState={false} //Estado inicial del componente
                onClick={hanldeNotifiesEmergencyTeamButton} //Accion cuando se hace CLICK
                forceDisable={!IsStarted} //Forzar la desactivacion la accion de este componente
                forceStop={ForceStopCase} //Forzar DETENER el temporizador
                minimal={PlatformMobile}
              />
              <NSCounter
                titleStart={"Monitor"} //Titulo por defecto cuando inicializa
                titleOn={"evaluaRitmo"} //Titulo cuando su estado esta activo
                titleOff={"evaluaRitmo"} //Titulo cuando su estado esta INACTIVO
                icon={iconMonitor} //Icono del componente
                type={"restart"} //tipo de componente personalizado
                options={ComponentOptions.monitorButton} //Opciones personalizadas del componente
                sum={0} //valor a sumar en el inicio del componente
                onStopTimer={(value) =>
                  !ForceStopCase
                    ? openModal("evaluarRitmo")
                    : closeModal("evaluarRitmo")
                } //Accion al DETENER el temporizador
                onStartTimer={(value) => {
                  handleStartMonitor(value);
                }} //Accion al INICIAR el temporizador
                list={ctxTimeline.monitor} //Lista de contexto para el conteo de elementos
                forceDisable={!IsStarted} //Forzar la desactivacion la accion de este componente
                forceStop={ForceStopCase} //Forzar DETENER el temporizador
                forceUpdate={modalState.evaluarRitmo} //forzar la ACTUALIZACION de un componente
                timeLimit={120}
                //Oculta el Temporizador y solo muestra el contador
                disableInitialTimer //Desactivar el temporizador en el inicio
                minimal={PlatformMobile}
              />
              {compresions && (
                <NSCounter
                  titleStart={"Inicia compresiones"} //Titulo por defecto cuando inicializa
                  titleOn={"Detiene compresiones"} //Titulo cuando su estado esta activo
                  titleOff={"Inicia compresiones"} //Titulo cuando su estado esta INACTIVO
                  icon={iconCompresiones} //Icono del componente
                  options={ComponentOptions.compressionsButton} //Opciones personalizadas del componente
                  sum={1} //valor a sumar en el inicio del componente
                  onStopTimer={handleStopTimerCompressions} //Accion al DETENER el temporizador
                  onStartTimer={handleStartTimerCompression} //Accion al INICIAR el temporizador
                  list={ctxTimeline.compressions} //Lista de contexto para el conteo de elementos
                  forceDisable={!IsStarted} //Forzar la desactivacion la accion de este componente
                  forceStop={ForceStopCase || forceStopPCR} //Forzar DETENER el temporizador
                  noCounter //Oculta el Temporizador y solo muestra el contador
                  initialState //Estado inicial del componente
                  minimal={PlatformMobile}
                />
              )}
              {compresions && (
                <NSCounter
                  titleStart={"Inicia ventilaciones"} //Titulo por defecto cuando inicializa
                  titleOn={"Detiene ventilaciones"} //Titulo cuando su estado esta activo
                  titleOff={"Inicia ventilaciones"} //Titulo cuando su estado esta INACTIVO
                  icon={iconVentilaciones} //Icono del componente
                  options={ComponentOptions.ventsButton} //Opciones personalizadas del componente
                  sum={1} //valor a sumar en el inicio del componente
                  onStopTimer={handleStopTimerVents} //Accion al DETENER el temporizador
                  onStartTimer={handleStartTimerVents} //Accion al INICIAR el temporizador
                  list={ctxTimeline.vents} //Lista de contexto para el conteo de elementos
                  forceDisable={!IsStarted || AsyncStatus} //Forzar la desactivacion la accion de este componente
                  forceStop={ForceStopCase || forceStopPCR} //Forzar DETENER el temporizador
                  noCounter //Oculta el Temporizador y solo muestra el contador
                  minimal={PlatformMobile}
                />
              )}
              {!compresions && (
                <NSCounter
                  titleStart={"Inicia RCP"} //Titulo por defecto cuando inicializa
                  titleOn={"Detiene RCP"} //Titulo cuando su estado esta activo
                  titleOff={"Inicia RCP"} //Titulo cuando su estado esta INACTIVO
                  icon={iconReanimacion} //Icono del componente
                  options={ComponentOptions.rcpButton} //Opciones personalizadas del componente
                  sum={1} //valor a sumar en el inicio del componente
                  onStopTimer={handleStopTimerRcp} //Accion al DETENER el temporizador
                  onStartTimer={handleStartTimerRcp} //Accion al INICIAR el temporizador
                  list={ctxTimeline.RCP} //Lista de contexto para el conteo de elementos
                  forceDisable={!IsStarted} //Forzar la desactivacion la accion de este componente
                  forceStop={ForceStopCase || forceStopPCR} //Forzar DETENER el temporizador
                  minimal={PlatformMobile}
                  noCounter
                />
              )}
              <NSCounter
                titleStart={"Desfibrilación"} //Titulo por defecto cuando inicializa
                titleOn={"Desfibrilación"} //Titulo cuando su estado esta activo
                titleOff={"Desfibrilación"} //Titulo cuando su estado esta INACTIVO
                icon={iconDesfibrilacion} //Icono del componente
                type={"restart"} //valor a sumar en el inicio del componente
                options={ComponentOptions.defibrillationButton} //Opciones personalizadas del componente
                sum={1} //valor a sumar en el inicio del componente
                onStopTimer={hanldeStopTimerDefibrillation} //Accion al DETENER el temporizador
                onStartTimer={handleStartTimerDefibrillation} //Accion al INICIAR el temporizador
                list={ctxTimeline.defibrillation} //Lista de contexto para el conteo de elementos
                forceDisable={!IsStarted} //Forzar la desactivacion la accion de este componente
                forceStop={ForceStopCase} //Forzar DETENER el temporizador
                noTimerHistorial
                onlyCounter //Oculta el Temporizador y solo muestra el contador
                minimal={PlatformMobile}
              />
              <NSCounter
                titleStart={"Adrenalina"} //Titulo por defecto cuando inicializa
                titleOn={"Adrenalina"} //Titulo cuando su estado esta ACTIVO
                titleOff={"Adrenalina"} //Titulo cuando su estado esta INACTIVO
                icon={iconAdrenalina} //Icono del componente
                type={"restart"} //valor a sumar en el inicio del componente
                options={ComponentOptions.adrenalinButton} //Opciones personalizadas del componente
                sum={0} //valor a sumar en el inicio del componente
                onStopTimer={handleStopTimerAdrennalin} //Accion al DETENER el temporizador
                onStartTimer={handleStartTimerAdrenalin} //Accion al INICIAR el temporizador
                list={ctxTimeline.adrenalin} //Lista de contexto para el conteo de elementos
                forceDisable={!IsStarted || !ctxTimeline.vascularAccess} //Forzar la desactivacion la accion de este componente
                forceStop={ForceStopCase} //Forzar DETENER el temporizador
                noTimerHistorial
                onlyCounter //Oculta el Temporizador y solo muestra el contador
                minimal={PlatformMobile}
              />
              <NSCounter
                titleStart={"Amiodarona"} //Titulo por defecto cuando inicializa
                titleOn={"Amiodarona"} //Titulo cuando su estado esta ACTIVO
                titleOff={"Amiodarona"} //Titulo cuando su estado esta INACTIVO
                icon={Ic_amiodarona} //Icono del componente
                type={"restart"} //valor a sumar en el inicio del componente
                options={ComponentOptions.amiodaroneButton} //Opciones personalizadas del componente
                sum={0} //valor a sumar en el inicio del componente
                onStopTimer={handleStopTimerAmiodarone} //Accion al DETENER el temporizador
                onStartTimer={handleStartTimerAmiodarone} //Accion al INICIAR el temporizador
                list={ctxTimeline.amiodarone} //Lista de contexto para el conteo de elementos
                forceDisable={!IsStarted || !ctxTimeline.vascularAccess} //Forzar la desactivacion la accion de este componente
                forceStop={ForceStopCase} //Forzar DETENER el temporizador
                noTimerHistorial
                onlyCounter //Oculta el Temporizador y solo muestra el contador
                minimal={PlatformMobile}
              />
              <NSIndicator
                title={"detectaCausasReversibles"} //Titulo por defecto cuando inicializa
                icon={iconCausaParada} //Icono del componente
                options={ComponentOptions.causaButton} //Opciones personalizadas del componente
                onClick={handleCausaParadaClick} //Accion cuando se hace CLICK
                forceDisable={!IsStarted} //Forzar la desactivacion la accion de este componente
                forceStop={ForceStopCase} //Forzar DETENER el temporizador
                values={[
                  { title: "H", status: ctxTimeline.CausaH.length > 0 },
                  { title: "T", status: ctxTimeline.CausaT.length > 0 },
                ]} //Valores personalizados del componente
                initialState //Estado inicial del componente
                minimal={PlatformMobile}
              />
              <NSIndicator
                title={"ecgRitmoPaciente"} //Titulo por defecto cuando inicializa
                icon={iconRitmoEcg} //Icono del componente
                type={"oneSelection"} //valor a sumar en el inicio del componente
                options={ComponentOptions.ritmoEcgButton} //Opciones personalizadas del componente
                onClick={() => {
                  handleEcgDialog(false, false);
                }} //Accion cuando se hace CLICK
                callbackCancel={() => {}} //Accion cuando se presiona CANCELAR
                forceDisable={!IsStarted && ForceStopCase} //Forzar la desactivacion la accion de este componente
                forceStop={ForceStopCase} //Forzar DETENER el temporizador
                forceUpdate={true} //forzar la ACTUALIZACION de un componente
                values={[
                  {
                    title: ctxTimeline.ecgPaciente,
                    status: ctxTimeline.ecgPaciente != "" ? true : false,
                  },
                ]} //Valores personalizados del componente
                initialState //Estado inicial del componente
                minimal={PlatformMobile}
              />
              <NSIndicator
                title={"tecnicasFarmacos"} //Titulo por defecto cuando inicializa
                icon={iconTecnicas} //Icono del componente
                values={[
                  { title: "T", status: ctxTimeline.Tecnicas.length > 0 },
                  { title: "F", status: ctxTimeline.Farmacos.length > 0 },
                ]}
                options={ComponentOptions.tecnicasButton} //Opciones personalizadas del componente
                onClick={hanldeTecnicasClick} //Accion cuando se hace CLICK
                forceDisable={!IsStarted} //Forzar la desactivacion la accion de este componente
                forceStop={ForceStopCase} //Forzar DETENER el temporizador
                initialState //Estado inicial del componente
                minimal={PlatformMobile}
              />
              <NSIndicator
                title={"Notas"} //Titulo por defecto cuando inicializa
                icon={iconNotas} //Icono del componente
                values={[{ status: ctxTimeline.Notas == "" ? false : true }]} //Valores personalizados del componente
                options={ComponentOptions.notesButton} //Opciones personalizadas del componente
                onClick={() => openModal("notas")} //Accion cuando se hace CLICK
                forceDisable={!IsStarted} //Forzar la desactivacion la accion de este componente
                forceStop={ForceStopCase} //Forzar DETENER el temporizador
                initialState //Estado inicial del componente
                minimal={PlatformMobile}
              />
            </div>
          </div>
        </div>

        {
          //#endregion
        }
      </div>
      {
        //#region DIALOGOS POPUP
      }

      <DialogVentilaciones
        text={"compresionesVentilaciones"} //Titulo por defecto cuando inicializa
        icon={Ic_chrono_L} //Icono del componente
        callbackConfirm={() => {
          handleCompresions();
          middleWare();
        }} //Accion cuando se presiona CONFIRMAR
        callbackCancel={() => {
          closeModal("ventilaciones");
          middleWare();
        }} //Accion cuando se presiona CANCELAR
        status={modalState.ventilaciones} //Estado del compononte (Visible || oculto)
      />

      <DialogRitmoInicial
        text={"initial_rhythm_question"} //Titulo por defecto cuando inicializa
        icon={Ic_heart} //Icono del componente
        callbackConfirm={(value) => {
          handleConfirmEcgPaciente(value);
          middleWare();
        }} //Accion cuando se presiona CONFIRMAR
        callbackCancel={() => closeModal("ritmoInicial")} //Accion cuando se presiona CANCELAR
        status={modalState.ritmoInicial} //Estado del compononte (Visible || oculto)
      />

      <DialogAccesoVascular
        text={"¿Este paciente es portador de acceso vascular?"} //Titulo por defecto cuando inicializa
        callbackConfirm={handleConfirmAcceso} //Accion cuando se presiona CONFIRMAR
        callbackCancel={handleCloseAcceso} //Accion cuando se presiona CANCELAR
        status={!IsStarted && !ForceStopCase && modalState.accesoVascular} //Estado del compononte (Visible || oculto)
      />

      {modalState.ritmoPaciente && (
        <DialogRitmoPaciente
          text={"ecgRitmoPaciente"} //Titulo por defecto cuando inicializa
          icon={iconRitmoEcg} //Icono del componente
          status={true} //Estado del compononte (Visible || oculto)
          currentState={PCRStatus}
          fromButtom={PCRFromButton}
          contexto={ctxTimeline} //Pasar el contexto por props
          setContexto={setCtxTimeLine} //Actualizar el contexto por props
          callbackCancel={() => handleEcgDialog(false, false)} //Accion cuando se presiona CANCELAR
          callbackConfirm={handleConfirmEcgPaciente} //Accion cuando se presiona CONFIRMAR
        />
      )}

      {modalState.evaluarRitmo && (
        <DialogEvaluaRitmo
          text={"Evalúa ritmo"} //Titulo por defecto cuando inicializa
          icon={iconRitmoEcg} //Icono del componente
          callbackConfirm={handleDialogConfirmEvaluaRitmo} //Accion cuando se presiona CONFIRMAR
          callbackCancel={() => closeModal("evaluarRitmo")} //Accion cuando se presiona CANCELAR
          status={true} //Estado del compononte (Visible || oculto)
          currentState={PCRStatus}
        />
      )}
      <DialogCausaParada
        icon={iconCausaParada} //Icono del componente
        status={modalState.causasParada} //Estado del compononte (Visible || oculto)
        callbackCancel={() => closeModal("causasParada")} //Accion cuando se presiona CANCELAR
        callbackConfirm={(H, T) => {
          updateContext("CausaH", []);
          updateContext("CausaT", []);
          const tempH = H.map((item, index) => {
            updateContextPush("CausaH", item);
            if (index == 0) {
              return `${item} `;
            }
            return `- ${item} `;
          });
          const tempT = T.map((item, index) => {
            updateContextPush("CausaT", item);
            if (index == 0) {
              return `${item} `;
            }
            return `- ${item} `;
          });
          if (tempH.length > 0) {
            updateHistory(
              "CausaH",
              +new Date(),
              "Causa PCR H: ",
              false,
              tempH,
              null,
              "red"
            );
          }
          if (tempT.length > 0) {
            updateHistory(
              "CausaT",
              +new Date(),
              "Causa PCR T: ",
              false,
              tempT,
              null,
              "blue"
            );
          }
          closeModal("causasParada"); //Cerrar el dialogo de causa de parada
        }} //Accion cuando se presiona CONFIRMAR
      />
      {modalState.tecnicasFarmacos && (
        <DialogTecnicasFarmacos
          title={"tecnicasFarmacos"} //Titulo por defecto cuando inicializa
          icon={iconTecnicas} //Icono del componente
          contexto={ctxTimeline}
          callbackConfirm={(F, T) => {
            updateContext("Farmacos", []);
            updateContext("Tecnicas", []);
            const tempF = F.map((item, index) => {
              updateContextPush("Farmacos", item);
              if (index == 0) {
                return `${item} `;
              }
              return `- ${item} `;
            });
            const tempT = T.map((item, index) => {
              updateContextPush("Tecnicas", item);
              if (index == 0) {
                return `${item} `;
              }
              return `- ${item} `;
            });
            if (tempF.length > 0) {
              updateHistory(
                "Farmacos",
                +new Date(),
                "Fármacos: ",
                false,
                tempF,
                null,
                "red"
              );
            }
            if (tempT.length > 0) {
              updateHistory(
                "Tecnicas",
                +new Date(),
                "Técnicas: ",
                false,
                tempT,
                null,
                "blue"
              );
            }
            closeModal("tecnicasFarmacos"); //Cerrar el dialogo de causa de parada
          }} //Accion cuando se presiona CONFIRMAR
          callbackCancel={() => {
            closeModal("tecnicasFarmacos");
          }} //Accion cuando se presiona CANCELAR
        />
      )}
      {modalState.notas && (
        <DialogDownNotes
          text={"Notas"} //Titulo por defecto cuando inicializa
          icon={iconNotas} //Icono del componente
          callbackConfirm={handleDialogConfirmNotes} //Accion cuando se presiona CONFIRMAR
          callbackCancel={() => closeModal("notas")} //Accion cuando se presiona CANCELAR
          status={true} //Estado del compononte (Visible || oculto)
          contexto={ctxTimeline}
        />
      )}
      <DialogHabilidades
        text={"dialogHabilidadesTitle"} //Titulo por defecto cuando inicializa
        callbackConfirm={handleStop} //Accion cuando se presiona CONFIRMAR
        callbackCancel={() => closeModal("habilidades")} //Accion cuando se presiona CANCELAR
        status={ForceStopCase && modalState.habilidades} //Estado del compononte (Visible || oculto)
        action01={() => openModal("noTecnicas")} //Accion al presionar el PRIMER boton
        action02={() => openModal("calidadRcp")} //Accion al presionar el SEGUNDO boton
        action03={() => openModal("medirAmbas")} //Accion al presionar el TERCER boton
        action04={() => {
          handleDialogFinish(); //Abre el PopUp para finalizar el registro
          closeModal("habilidades"); // cierra el popup de habilidades
        }} //Accion al presionar el CUARTO boton
      />
      <DialogNoTecnicas
        callbackConfirm={() => {}} //Accion cuando se presiona CONFIRMAR
        callbackCancel={() => handleDialogNoTecnicasStop()} //Accion cuando se presiona CANCELAR
        status={modalState.noTecnicas} //Estado del compononte (Visible || oculto)
        volverNoTecnicas={() => closeModal("noTecnicas")} //Accion al presionar VOLVER en No Tecnicas
        actionNoTecnicas={() => handleSaveAndCloseNotecnicas()} //Accion al presionar GUARDAR en No Tecnicas
        saveAnd={"Guardar y generar informe"} //Titulo personalizado del boton guardar
        noBackground
      />

      <DialogCalidadRcp
        callbackConfirm={() => {}} //Accion cuando se presiona CONFIRMAR
        callbackCancel={() => handleDialogCalidadRcpStop()} //Accion cuando se presiona CANCELAR
        status={modalState.calidadRcp} //Estado del compononte (Visible || oculto)
        volverCalidadRcp={() => closeModal("calidadRcp")} //Accion al presionar VOLVER en calidad RCP
        actionCalidadRcp={() => handleSaveAndCloseCalidadRcp()} //Accion al presionar GUARDAR en calidad RCP
        saveAnd={"Guardar y generar informe"} //Titulo personalizado del boton guardar
        noBackground
      />
      <DialogMedirAmbas
        callbackConfirm={handleDialogMedirAmbasConfirm} //Accion cuando se presiona CONFIRMAR
        callbackCancel={handleMedirAmbasStop} //Accion cuando se presiona CANCELAR
        status={modalState.medirAmbas} //Estado del compononte (Visible || oculto)
      />
      {modalState.finish && (
        <DialogFinish
          onSaveReport={SaveReport} //Accion cuando se presiona CONFIRMAR
          callbackCancel={() => closeModal("finish")} //Accion cuando se presiona CANCELAR
          selectedReport={ctxTimeline} //Pasar por props el reporte seleccionado
          onUpdateContext={updateContext}
        />
      )}
      {
        //#endregion
      }
    </>
  );
};
export default Advanced;

//#region TABLA DE ESTILOS
const styles = {
  switcherSection: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  buttonsSeccion: {
    paddingBottom: "20px",
  },
  footer: {
    bottom: 0,
    position: "fixed",
    width: "100%",
    height: "80px",
    background: "#2AAC9C",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};
//#endregion
